import dayjs, { type Dayjs } from 'dayjs';

// Marks a page that is still slated for retirement with no date agreed yet: the banner keeps
// warning, but nothing hides or redirects (that is driven by a route's `retiredDate`).
export const SUNSET_DATE_TBD = 'TBD' as const;

export type RetirementDate = Dayjs | typeof SUNSET_DATE_TBD;

// A retired page stays available through its retirement date; the redirect to the common sunset
// page (PFM-1426) and hiding it from the menu go live the day after.
export const isPastRetirement = (retirementDate: Dayjs): boolean =>
  dayjs().isAfter(retirementDate, 'day');
